import { render, staticRenderFns } from "./paidan.vue?vue&type=template&id=de3a3e78"
import script from "./paidan.vue?vue&type=script&lang=js"
export * from "./paidan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports